<template>
  <div class="map-item-filter">
    <div
      class="col-sm-12 nopads vehicle-list"
      :class="{ list_closed: !listOpen }"
    >
      <span
        class="vehicle-list-title"
        @click.stop="toggleList"
      >
        {{ $t('menu.work_assignment') }} ({{ count }})
      </span>
      <div
        class="vehicle-list-caret"
        :class="{ caret_open: listOpen }"
        @click.stop="toggleList"
      >
        <font-awesome-icon icon="caret-down" />
      </div>
      <div
        v-if="listOpen"
        class="col-sm-12 nopads vehicle-list-container"
        style="overflow-x: hidden"
      >
        <div
            v-if="selectedContractIds && selectedContractIds.length > 0"
            class="badge-filters__wrapper mx-2 mt-3">
            <div class="badge-filters">
              <span
                  v-for="item in statusFilters"
                  :key="item.value"
                  class="badge me-2"
                  :class="isActiveStatusFilter(item.value) ? 'bg-primary text-white' : 'bg-light text-dark'"
                  style="cursor: pointer; padding: .5em 1em"
                  @click="toggleStatusFilter(item.value)"
              >
                {{ item.text }}
              </span>
            </div>
        </div>

        <hr
            class="nopads px-2 mb-2"
            style="border-color: #6e914c"
        >
          <!-- Created time filters -->
        <div class="badge-filters__wrapper">
              <div class="badge-filters px-2 pt-2">
                    <span
                        v-for="(item, index) in timeFilters"
                        :key="index"
                        :class="['badge', 'ml-2', isActiveTimeFilter(item.value) ? 'bg-primary text-light' : 'bg-light text-dark', 'py-1', 'px-2']"
                        style="cursor: pointer"
                        @click="toggleTimeFilter(item.value)"
                    >
                        {{ item.text }}
                    </span>
              </div>
        </div>

        <!-- Slider -->
        <div v-if="selectedTimeFilter === 1"  class="col-12 px-2">
              <div class="row nopads">
                  <div class="col-sm-8">
                  </div>
                  <div class="col-sm-4 d-flex justify-content-end">
                      <span class="vehicle-list-no-results nopads text-end">{{ days + ' ' + 'd' }}</span>
                  </div>
              </div>
              <input
                  id="range"
                  v-model="days"
                  type="range"
                  class="form-range mb-2"
                  :min="minDays"
                  :max="maxDays"
                  @change="emitFilterOptions"
              >
          </div>

          <!-- User input dates -->
          <div v-if="selectedTimeFilter === 2">
              <div class="d-flex flex-row mb-2">
                  <div class="col-sm-6 px-2">
                        <span class="date-picker-label text-light">
                          {{ $t('map_filters.create_date_from') }}
                        </span>
                      <date-time-picker
                          v-model:date="createDateFrom"
                          class="routa-input"
                          format="dd.MM.yyyy"
                          :enable-time-picker="false"
                          :clearable="true"
                      />
                  </div>
                  <div class="col-sm-6 px-2">
                        <span class="date-picker-label text-light">
                          {{ $t('map_filters.create_date_to') }}
                        </span>
                      <date-time-picker
                          v-model:date="createDateTo"
                          class="routa-input"
                          format="dd.MM.yyyy"
                          :enable-time-picker="false"
                          :clearable="true"
                      />
                  </div>
              </div>
              <div class="button-container pb-2 px-2">
                  <button
                      size="md"
                      class="btn btn-sm btn-success"
                      :disabled="!createDateFrom || !createDateTo"
                      @click.stop="emitFilterOptions"
                  >
                      <span class="map-button-text">{{ $t('ins_report.search') }}</span>
                  </button>
              </div>
          </div>

          <hr
              class="nopads px-2 mb-2"
              style="border-color: #6e914c"
          >

          <!-- Assigned by me & My responsibility -->
          <div class="d-flex flex-row mb-2 px-2">
              <div class="col-lg-6">
                  <div class="form-check d-flex align-items-center">
                      <input
                          id="assigner"
                          v-model="assignedByUser"
                          type="checkbox"
                          class="form-check-input"
                      >

                      <label
                          class="form-check-label px-2 pt-1"
                          style="color: #ffffff; font-size: .9em"
                          for="assigner"
                      >
                          {{ $t('work_assignment.assigned_by_user') }}
                      </label>
                  </div>
              </div>
              <div class="col-lg-6">
                  <div class="form-check d-flex align-items-center">
                      <input
                          id="responsible"
                          v-model="userResponsible"
                          type="checkbox"
                          class="form-check-input"
                      >

                      <label
                          class="form-check-label px-2 pt-1"
                          style="color: #ffffff; font-size: .9em;"
                          for="responsible"
                      >
                          {{ $t('work_assignment.user_responsible') }}
                      </label>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>
<script>
import {restApi} from '../mixins/RestApiMixin'
import DateTimePicker from "@/components/common/DateTimePicker.vue";

const STATUS = {
    INCOMPLETE: null,
    ALL: 0,
    OPEN: 1,
    INPROGRESS: 2,
    ASSIGNED: 3,
    READY: 10,
}

export const historyModes = {
    ALL: null,
    SLIDER: 1,
    USER_INPUT: 2
}

export default {
    name: "WorkAssignmentFilter",
    components: {DateTimePicker},
    mixins: [restApi],
    props: {
        selectedContractIds: {
            type: Array,
            default() {
                return []
            }
        },
        filters: {
            type: Object,
            default: null
        },
        count: {
            type: Number,
            default: 0
        }
    },
    data() {
        return {
            mounted: false,
            isOpen: true,
            loading: false,
            listOpen: false,
            days: 7,
            minDays: 1,
            maxDays: 30,
            createDateFrom: null,
            createDateTo: null,
            selectedTimeFilter: historyModes.ALL,
            userResponsible: false,
            assignedByUser: false,
            selectedStatusFilter: [STATUS.OPEN],
            statusFilters: [
                {
                    text: this.$t("common.all"),
                    value: STATUS.ALL,
                },
                {
                    text: this.$t("common.open"),
                    value: STATUS.OPEN,
                },
                {
                    text: this.$t("common.in_progress"),
                    value: STATUS.INPROGRESS,
                },
                {
                    text: this.$t("work_assignment.assigned"),
                    value: STATUS.ASSIGNED,
                },
                {
                    text: this.$t("map_filters.contracts_ready"),
                    value: STATUS.READY,
                },
            ],
            timeFilters: [
                {text: this.$t('common.all'), value: historyModes.ALL},
                {text: "1-30 d", value: historyModes.SLIDER},
                {text: this.$t('common.time_range'), value: historyModes.USER_INPUT},
            ],

        };
    },
    computed: {
        amountOfFiltersSelected() {
            return (this.selectedTimeFilters ? 1 : 0) + (this.selectedContractId ? 1 : 0)
        }
    },
    watch: {
        selectedStatusFilter(val) {
            this.emitFilterOptions()
        },
        selectedTimeFilter(val) {
            this.emitFilterOptions()
        },
        userResponsible() {
            this.emitFilterOptions()
        },
        assignedByUser() {
            this.emitFilterOptions()
        }
    },
    mounted() {
        // Set filters
        if (this.filters) {
            // Set status
            this.selectedTypes = this.filters.types
            this.selectedTimeFilter = this.filters.history
            this.days = this.filters.sliderValue
            this.createDateFrom = this.filters.createdFrom
            this.createDateTo = this.filters.createdTo
            this.userResponsible = this.filters.userResponsible
            this.assignedByUser = this.filters.assignedByUser
            this.selectedStatusFilter = this.selectedContractIds && this.selectedContractIds.length > 0 &&
                Array.isArray(this.filters?.status) ? this.filters.status : [STATUS.OPEN]
        }

        this.mounted = true
    },
    methods: {
        toggleStatusFilter(val) {
            if (val === STATUS.ALL) {
                // If the value is 0, clear all other filters and select only 0
                this.selectedStatusFilter = this.selectedContractIds && this.selectedContractIds.length > 0 ? [STATUS.ALL] : [STATUS.OPEN, STATUS.INPROGRESS, STATUS.ASSIGNED];
            } else {
                // If 0 is already selected, remove it
                this.selectedStatusFilter = this.selectedStatusFilter.filter(item => item !== STATUS.ALL);
                const index = this.selectedStatusFilter.indexOf(val);
                if (index > -1) {
                    // If the filter is already selected, remove it
                    this.selectedStatusFilter.splice(index, 1);
                } else {
                    // If the filter is not selected, add it
                    this.selectedStatusFilter.push(val);
                }
            }
        },
        isActiveStatusFilter(val) {
            return this.selectedStatusFilter.includes(val);
        },
        toggleList: function () {
            this.listOpen = !this.listOpen
        },
        toggleTimeFilter(val) {
            this.selectedTimeFilter = val
        },
        isActiveTimeFilter(val) {
            return val === this.selectedTimeFilter
        },
        emitFilterOptions() {
            if (this.mounted) {
                let filters = {
                    "history": this.selectedTimeFilter,
                    "sliderValue": this.days,
                    "createdFrom": this.createDateFrom,
                    "createdTo": this.createDateTo,
                    "status": this.selectedStatusFilter,
                    "types": this.selectedTypes,
                    "assignedByUser": this.assignedByUser,
                    "userResponsible": this.userResponsible
                }
                this.$emit('filtersUpdated', filters)
            }
        }
    },
}
</script>
<style lang="scss" scoped>
.badge-filters {
    display: flex;
    gap: 0.5rem;
    margin-bottom: 1rem;
    flex: 5;
    flex-wrap: wrap;
    & > * {
        cursor: pointer;
    }
    &__wrapper {
        display: flex;
        align-items: flex-start;
    }
}

.date-picker-label {
    margin-top: .5em;
    font-size: .9em;
}
</style>
